export default __webpack_public_path__ + "static/media/torso-low-left-side.ca62d56c.png";